// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"71e9714ea09df89d","6226":"0e4e5f500e14b64b"}[chunkId] + ".css";
};